'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import RadialData from './RadialData';

var PageRequestsRadialData = /*#__PURE__*/function (_RadialData) {
  _inherits(PageRequestsRadialData, _RadialData);

  function PageRequestsRadialData() {
    _classCallCheck(this, PageRequestsRadialData);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageRequestsRadialData).apply(this, arguments));
  }

  _createClass(PageRequestsRadialData, [{
    key: "init",
    value: function init(grade) {
      _get(_getPrototypeOf(PageRequestsRadialData.prototype), "init", this).call(this, grade);

      this.displayRecommendationValue = '< 30';
    }
  }, {
    key: "setGradeType",
    value: function setGradeType(grade) {
      this.gradeType = this.getGoodOkBadGradeType(grade, 30, 80);
    }
  }, {
    key: "setScore",
    value: function setScore(grade) {
      this.score = Math.min(grade, 100);
    }
  }, {
    key: "setDisplayValue",
    value: function setDisplayValue(grade) {
      this.displayValue = grade;
    }
  }]);

  return PageRequestsRadialData;
}(RadialData);

export default PageRequestsRadialData;